//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DotError from "~/components/projects/DotError";


  // const ipfs = require('ipfs-http-client')
  // const ipfsBaseUrl = 'https://ipfs.infura.io/ipfs/'
  // const clientIpfs = ipfs.create('https://ipfs.infura.io:5001/api/v0')
  const authorizedExtension = {
    image: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
    script: ['.js']
  }

  export default {
    name: "Upload",
     components:{
       DotError
    },
    props: {
      type: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: 'Upload File'
      },
      accept: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      hint: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      rules: {
        type: Array,
        default: null
      },
      errors: {
        type: Object,
        default: null
      },
      errorKey: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        fileSrc: '',
        buffer: {},
        filesToUpload: [],
        files: [],
        isLoading: false,
        file: null,
        uploadRules: {
          upload: [
            value => (!!value || !this.required) || 'File is required.',
          ]
        },
      };
    },
    created() {
      if (this.rules && this.rules.length > 0) {
        this.uploadRules.upload.push(...this.rules)
        console.log(this.uploadRules.upload)
      }
    },
    methods: {
      authorizedExtension() {
        if (authorizedExtension) {
          return authorizedExtension[this.accept].join(',')
        }
      },
      chooseFile(file) {
        if (file) {
          // Use the javascript reader object to load the contents
          // of the file in the v-model prop

          this.isLoading = true
          this.$emit('load', this.isLoading)

          if (authorizedExtension[this.accept].includes(file.type)) {
            this.isLoading = false

            this.$emit('load', this.isLoading)
            this.$emit('input', file)
            this.$emit('upload', this.name)
          }
          else {
            this.file = undefined
            this.isLoading = false

            this.$emit('load', this.isLoading)
            this.$emit('input', null)
            this.$emit('upload', this.name)
          }
        }
      },
      chooseFolder(files) {
        // Add image-only files to upload array
        // const promises = []

        if (files) {
          for (const index in files) {
            // Use the javascript reader object to load the contents
            // of the file in the v-model prop
            const file = files[index]

            if (!authorizedExtension[this.accept].includes(file.type)) {
              files.splice(index, 1)
            }
          }

          this.$emit('upload', files, this.id)
        }
      },
    }
  }
